export const cartQueryKeys = {
  all: ['cart'] as const,
  calculate: (cartHash: string, depsHash: string) =>
    ['cart', 'calculate', cartHash, depsHash] as const,
};
